import { GRID_CHECKBOX_SELECTION_COL_DEF, GridCellParams, GridColDef, GridRowId, GridRowSelectionModel } from "@mui/x-data-grid"
import { Box, Checkbox, FormControlLabel, Tooltip, Typography } from "@mui/material"
type StudentCustomCheckboxProps = {
    title: string,
    selectionModel: (string | number)[],
    handleSelectionModelChange: (values: (string | number)[]) => void;
    handleSelectAll: (selectAll: boolean) => void;
    companyConsentPolicy?: boolean;
    totalRowCount: number;
    dataTour?: string;

}
const enum ParentalConsentType {
    Given = 'GIVEN',
    Pending = 'PENDING',
    Rejected = 'REJECTED',
    Timelapsed = 'TIMELAPSED'
}
const enum DisableMessage {
    studentExpired = "This student is currently archived, you must re-activate the student's file before launching a session",
    noEmail = "This student does not have an email associated with the account, please provide an email before launching a remote session",
    maxStudents = "You can only launch 30 students at a time, please submit and then launch your next batch of students",
    mustReview = "You cannot mark this as read from this table. You must go to the Student's file and review their session",
    consentNotGiven = "The parent has not given consent to launch a session",
    consentPending = "The parental consent is pending, please wait until they have given it"
}
const StudentCustomCheckbox = ({ title, selectionModel, dataTour, handleSelectionModelChange, handleSelectAll, companyConsentPolicy, totalRowCount }: StudentCustomCheckboxProps): GridColDef => {
    const handleHeaderCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectAll = event?.target.checked;
        // console.log("do we want to select all, true = select: ", selectAll)
        handleSelectAll(selectAll);
    }
    const isSelectAll = selectionModel.length === totalRowCount
    const isIndeterminate = selectionModel.length > 0 && selectionModel.length < totalRowCount
    return {
        ...GRID_CHECKBOX_SELECTION_COL_DEF,
        // headerAlign: "center",
        sortable: false, editable: false, disableColumnMenu: true,
        flex: .5,
        field: "customcheckbox",
        headerName: title,
        //  minWidth: 50,
        renderHeader: () => {
            return (
                <FormControlLabel
                    label={title}
                    data-tour={dataTour}
                    slotProps={{
                        typography: {
                            sx: { fontSize: "0.875rem", fontWeight: 500, lineHeight: 1, whiteSpace: "break-spaces", paddingLeft: ".5rem", textAlign: "center", }
                        }
                    }}
                    sx={{ margin: 0 }}
                    control={<Checkbox
                        checked={isSelectAll}
                        indeterminate={isIndeterminate}
                        onChange={handleHeaderCheck}
                        style={{ display: "none" }}
                    />
                    }
                />
            )
        },
        renderCell: (params: GridCellParams) => {
            let disabledMessage;
            const studentStatus = title === "Mass Launch" ? params.row.expired : false;
            const isEmailPresent = title === "Mass Launch" ? params.row.email : true;
            const maxReached = title === "Mass Launch" ? selectionModel.length > 30 : false;
            const consentPending = title === "Mass Launch" && (companyConsentPolicy && params.row?.parentalConsentStatus?.toUpperCase() == ParentalConsentType.Pending) ? true : false
            const noConsent = title === "Mass Launch" && (companyConsentPolicy && (params.row?.parentalConsentStatus?.toUpperCase() == ParentalConsentType.Rejected || params.row.parentalConsentStatus == null)) ? true : false
            const isSuicidal = title === "Mark as Read" && params.row.reason === "Urgent" ? true : false
            const _selectionModelIds = Array.from(selectionModel)
            if (studentStatus) {
                disabledMessage = DisableMessage.studentExpired;
            } else if (!isEmailPresent) {
                disabledMessage = DisableMessage.noEmail;
            } else if (maxReached) {
                disabledMessage = DisableMessage.maxStudents;
            } else if (isSuicidal) {
                disabledMessage = DisableMessage.mustReview;
            } else if (consentPending) {
                disabledMessage = DisableMessage.consentPending
            } else if (noConsent) {
                disabledMessage = DisableMessage.consentNotGiven
            }
            else {
                disabledMessage = ""
            }

            var isChecked = selectionModel.includes(params.row.id)

            return (
                <Tooltip title={disabledMessage} >
                    <Box>
                        <Checkbox
                            checked={isChecked}
                            onChange={() => {
                                const newSelection = _selectionModelIds.includes(params.row.id)
                                    ? _selectionModelIds.filter((selectedId) => selectedId !== params.row.id)
                                    : [..._selectionModelIds, params.row.id]
                                handleSelectionModelChange(newSelection)
                                // handleSelectionModelChange({ type: 'include', ids: new Set(newSelection) })                                // handleCheckboxChange(params.row.id);
                            }}
                            disabled={Boolean(disabledMessage)}
                        />
                    </Box>
                </Tooltip >
            )
        }
    }
}

export default StudentCustomCheckbox